import { IconInfo } from "@synthesis/shared-icons";
import { Tooltip, type TooltipProps } from "@synthesis/shared-ui";
import { cn } from "@synthesis/shared-utils";

type CreateApplicationInfoMarkProps = {
  description: string;
  ariaLabel?: string;
  arrowSide?: TooltipProps["arrowSide"];
  maxWidth?: string;
  className?: string;
};

export const CreateApplicationInfoMark = ({
  description,
  ariaLabel = "Показать подсказку",
  arrowSide = "top",
  maxWidth,
  className,
}: CreateApplicationInfoMarkProps) => (
  <Tooltip description={description} arrowSide={arrowSide} maxWidth={maxWidth}>
    <button type="button" className={cn("block size-5", className)} aria-label={ariaLabel}>
      <IconInfo className="text-neutrals-60 size-5" />
    </button>
  </Tooltip>
);
